module.exports = {
    baseUrl:'https://engine.mosqapp.com/api',
    mobileURL:process.env.REACT_APP_MOBILE_SERVER_URL,
    apiURL:process.env.REACT_APP_API_URL,
    adminURL:process.env.REACT_APP_ADMIN_URL ,
    csvDoUrl:process.env.REACT_APP_CSV_DO_URL
};
    
